<template>
  <div id="car-card" @click="selectVehicle" @mouseover="selectVehicle" @mouseleave="deselectVehicle">
    <h2 class="title">{{ car.contract_tag }}</h2>
    <p class="text">{{ car.contract_type }}</p>
    <hr />
    <p class="text">Placas: {{ car.license_plate }}</p>
    <p class="text">Modelo: {{ car.model }}</p>
    <p class="text">Marca: {{ car.brand }}</p>
    <p class="text">Año: {{ car.year }}</p>
    <div class="link flex justify-center">
      <button class="btn" @click="goToAddCredit" >Realizar {{ addCreditLabel }}</button>
    </div>
    <InformationModal
      @confirm="showInformationModal = false"
      :active="showInformationModal"
      title="Atención"
    >
      <template #content>
        Estimado usuario, el TAG {{ car.contract_tag }} se encuentra inhabilitado, favor de contactar con el equipo de línea exprés para resolver su aclaración.
      </template>
    </InformationModal>
    <InformationModal
      @confirm="showMixedContractModal = false"
      :active="showMixedContractModal"
      title="Atención"
    >
      <template #content>
        Estimado usuario, por el momento las renovaciones de contratos mixtos se encuentran inhabilitadas en la plataforma, favor de contactar con el equipo de línea exprés para realizar su renovación.
      </template>
    </InformationModal>
  </div>
</template>

<script>
import InformationModal from '@/components/InformationModal'

export default {
  name: 'CarCard',
  components: {
    InformationModal
  },
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showInformationModal: false,
      showMixedContractModal: false
    }
  },
  computed: {
    carDetailUrl () {
      return `/vehicle/${this.car.id}`
    },
    addCreditLabel () {
      if (this.car.contract_type === 'Saldo') {
        return 'Recarga'
      }
      return 'Renovación'
    }
  },
  methods: {
    selectVehicle: function () {
      this.$emit('selectVehicle', this.car.id)
    },
    deselectVehicle: function () {
      this.$emit('selectVehicle', null)
    },
    goToAddCredit: function () {
      if (this.car.can_recharge) {
        this.$router.push(this.carDetailUrl)
      } else {
        this.showInformationModal = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

hr {
  background-color: #707070;
  border: none;
  height: 1px;
  margin-block-start: .5rem;
  margin-block-end: .5rem;
  width: 85%;
}

#car-card {
  background-color: $white;
  border-radius: 2rem;
  color: #707070;
  margin-top: 2rem;
  width: 20%;
  height: 16rem;
  margin-right: calc(20% / 3);
  padding-top: 1%;

  &:nth-child(4n) {
    margin-right: 0;
  }
}
.selectable {
  cursor: pointer;
}
.icon {
  margin: 1rem 1rem 0 0;
  width: 1rem;
}

.title {
  font-size: 1.25rem;
  margin: 0 0 .20rem 0;
}

.text {
  margin: 0 0 .5rem 0;
}
.visibility-hidden {
  visibility: hidden;
}

.link {
  cursor: pointer;
  margin-top: 10%;
}

.btn {
  border-radius: 20px;
  color: $white;
  border: 0;
  padding: 1em 2em;
  cursor: pointer;
  background-color: #008AB3;

  &:focus {
    opacity: 70%;
    outline-width: 0;
  }
  &:hover {
    opacity: 70%;
    outline-width: 0;
  }
}

@media(max-width: 90rem) {
  hr {
    margin-block-start: .5rem;
    margin-block-end: 1rem;
  }

  .icon {
    width: .75rem;
  }

  .title {
    font-size: 1.25rem;
  }
}

@media screen and (max-width: 480px) {
  #car-card {
    margin-top: 2rem;
    width: 80%;
    margin-right: 5%;
  }
}
</style>
